module.exports = __webpack_public_path__ + "static/media/05 REGGIANA CALCIO Villa Granata.5176fb4f.svg";